import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../config';
import DataHealthSourcesTable from './DataHealthSourcesTable';
import DataHealthDailyChart from './DataHealthDailyChart';

const DAILY_CHART_DAYS = 8;

export default function DataHealth({ fetchWithAuth }) {
  const { t } = useTranslation();
  const [sourceRows, setSourceRows] = useState([]);
  const [dailyRows, setDailyRows] = useState([]);
  const [sourcesLoading, setSourcesLoading] = useState(true);
  const [dailyLoading, setDailyLoading] = useState(true);

  useEffect(() => {
    const fetchSources = async () => {
      try {
        const response = await fetchWithAuth(`${API_BASE_URL}/api/statistics/dataHealth`);
        const data = await response.json();
        setSourceRows(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching data health:', error);
      } finally {
        setSourcesLoading(false);
      }
    };

    const fetchDaily = async () => {
      try {
        const response = await fetchWithAuth(`${API_BASE_URL}/api/statistics/dailyCountBySource?days=${DAILY_CHART_DAYS}`);
        const data = await response.json();
        setDailyRows(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching daily counts:', error);
      } finally {
        setDailyLoading(false);
      }
    };

    fetchSources();
    fetchDaily();
  }, [fetchWithAuth]);

  return (
    <div className="p-6 space-y-8">
      <div>
        <h2 className="text-2xl font-bold mb-2">{t('Data health')}</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {t('Latest ingestion activity per source and aggregation volume over the last days.')}
        </p>
      </div>

      <section>
        <h3 className="text-xl font-bold mb-4">{t('Sources freshness')}</h3>
        <DataHealthSourcesTable rows={sourceRows} loading={sourcesLoading} />
      </section>

      <section>
        <h3 className="text-xl font-bold mb-4">
          {t('Aggregated pictures per source (last {{count}} days)', { count: DAILY_CHART_DAYS })}
        </h3>
        <DataHealthDailyChart rows={dailyRows} loading={dailyLoading} />
      </section>
    </div>
  );
}
